import { useEffect, useState } from "react";
import MovieCard from "./MovieCard";
import "../styles.css";

export default function Watchlist({ watchlist, toggleWatchlist, genres = {} }) {
  const [watchlistMovies, setWatchlistMovies] = useState([]);
  const API_KEY = process.env.REACT_APP_TMDB_API_KEY;

  useEffect(() => {
    if (watchlist.length === 0) {
      setWatchlistMovies([]);
      return;
    }

    // ✅ Fetch details for each movie in the watchlist
    Promise.all(
      watchlist.map((id) =>
        fetch(
          `https://api.themoviedb.org/3/movie/${id}?api_key=${API_KEY}&language=en-US`
        ).then((res) => res.json())
      )
    )
      .then((movies) => setWatchlistMovies(movies))
      .catch((err) => console.error("Error fetching watchlist movies:", err));
  }, [watchlist, API_KEY]);

  return (
    <div className="watchlist-page">
      {watchlistMovies.length === 0 ? (
        <p>Your watchlist is empty.</p>
      ) : (
        <div className="movies-grid">
          {watchlistMovies.map((movie) => (
            <MovieCard
              key={movie.id}
              movie={movie}
              toggleWatchlist={toggleWatchlist}
              isWatchlisted={true} // ✅ always true, since it's the watchlist
              genres={genres}
            />
          ))}
        </div>
      )}
    </div>
  );
}
